import React from 'react';
import SchemaRegistry from "../../components/schema/registry/SchemaRegistry";
import {SchemaFields} from "../../types/Schema";
import ContentBlocker from "../../components/context/ContentBlocker";

const SCHEMAS_FIELDS: Array<SchemaFields> = [
  'id',
  'label',
  'bound',
  'updated',
  'created',
  'creator',
  'versionInfo',
  'objectsCount',
  'propertiesCount'
];

export default function SchemaRegistryPage() {
  return (
    <div className="SchemaRegistryPage">
      <h1>Schemas</h1>
      <ContentBlocker checkReadPermission={true}>
        <SchemaRegistry fields={SCHEMAS_FIELDS} showActions={true}/>
      </ContentBlocker>
    </div>
  );
}
